
import { add } from './position';


export default (function (droppable, point) {
  var closestScrollable = droppable.viewport.closestScrollable;
  if (!closestScrollable) {
    return point;
  }

  return add(point, closestScrollable.scroll.diff.displacement);
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-beautiful-dnd/esm/state/with-droppable-displacement.js
// module id = 108
// module chunks = 0